/* global pluralize */

(function () {
  'use strict';

  /* sanitizeThenDecode --
      given a sanitizer, $sanitize, sanitize a string,m str, then decode remaining html-escaped characters
  */
  var sanitizeThenDecode = function () {
    function decode(html) {
      var txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    }
    return function sanitizeThenDecode($sanitize, str) {
      var sanitized = $sanitize(str);
      var utfDecoded = decode(sanitized);
      return utfDecoded;
    };
  }();

  /* Filters */

  angular.module('wsLrs.filters', []).filter('capitalize', function () {
    return function (str) {
      str = str || '';
      var startIndex = str.startsWith("-") ? 1 : 0;
      return (startIndex === 1 ? str.charAt(0) : '') + str.charAt(startIndex).toUpperCase() + str.slice(startIndex + 1).toLowerCase();
    };
  }).filter('truncateAroundMatch', function () {
    return function (str, len, query) {
      query = query.toLowerCase();
      if (str.length <= len) {
        // Return the whole string since it's under our length limit
        return str;
      } else {
        var firstHit = str.toLowerCase().indexOf(query);
        if (firstHit > 0) {
          var startIdx = firstHit > len / 2 ? firstHit - len / 2 : 0;
          var endIdx = firstHit + len / 2 > str.length + 1 ? str.length - 1 : firstHit + len / 2;
          return (startIdx > 0 ? "" : "...") + str.substring(startIdx, endIdx) + "...";
        } else {
          // Simply truncation the original string, no matches
          return str.substring(0, len - 1) + "...";
        }
      }
    };
  }).filter('fromNow', function () {
    return function (date) {
      return typeof date === 'undefined' || date === null ? '--' : moment.utc(date).fromNow();
    };
  }).filter('formatDate', function () {
    return function (date, timeZone) {
      if (typeof date === 'undefined' || date === null) {
        return '--';
      } else {
        var dt = moment.utc(date);
        if (typeof timeZone === 'undefined' || timeZone === null) {
          return dt.format('ll');
        } else {
          return dt.tz(timeZone).format('ll');
        }
      }
    };
  }).filter('subtractDays', function () {
    return function (date, days) {
      return moment(date).subtract(days, "days").toDate();
    };
  }).filter('stripMailto', function stripMailto() {
    return function (input) {
      return (input || '').replace('mailto:', '');
    };
  }).filter('humanize', function () {
    return function (seconds) {
      if (typeof seconds === "undefined" || seconds === null) {
        return "";
      }
      if (seconds === 0) {
        return "--";
      } else {
        return moment.duration(seconds * 1000).humanize();
      }
    };
  }).filter('reverse', function () {
    return function (items) {
      return items.slice().reverse();
    };
  }).filter('unescape', function () {
    return _.unescape;
  }).filter('decodeURI', function () {
    return function (string) {
      try {
        return decodeURIComponent(string);
      } catch (e) {
        return string;
      }
    };
  }).filter('highlight', ['$sce', function ($sce) {
    return function (string, query, color) {
      if (!query || !string) {
        return string;
      }
      var style = color ? ' style="background-color:' + color + '"' : '';

      // wraps text that matches query with "mark" tags
      var replacement = '<mark' + style + '>$&</mark>';

      // escape any special characters in query
      query.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
      return $sce.trustAsHtml(('' + string).replace(new RegExp(query, 'gi'), replacement));
    };
  }]).filter('toString', function () {
    return function (object) {
      return object.toString();
    };
  }).filter('esFieldDisplayName', ['Utils', function (Utils) {
    return function (fields) {
      // Expecting an array
      if (!Utils.isArray(fields)) {
        fields = [fields];
      }
      var displayNames = _.map(fields, function (field) {
        var regExp = /\[.*\]/g;
        var match = regExp.exec(field);
        if (match && match.length > 0) {
          field = field.replace(regExp, match[0].replace(/\./g, "|dot|"));
        }
        var displayName = "";
        var foundExtension = false;
        _.each(field.split('.'), function (part) {
          if (foundExtension) {
            if (part.indexOf("]") > 0) {
              var urlParts = part.split("/");
              part = urlParts[urlParts.length - 1].replace("]", "");
              part = part.replace(/([A-Z])/g, ' $1').toLowerCase();
              part = part.replace("_", " ");
              displayName += part + " ";
            } else if (part.indexOf("__arr__") < 0) {
              part = part.replace(/([A-Z])/g, ' $1').toLowerCase();
              part = part.replace("_", " ");
              displayName += part + " ";
            }
          }
          if (part === "extensions") {
            foundExtension = true;
          }
        });
        return displayName.trim();
      });
      if (displayNames.length === 1) {
        return displayNames[0];
      } else {
        return displayNames;
      }
    };
  }]).
  // Converts a list of items into a list of lists of items, with three in each inner list.
  // Essentially a pagination function.
  filter('rows', function () {
    return _.memoize(function (input) {
      return _.groupBy(input, function (a, b) {
        return Math.floor(b / 3);
      });
    }, function (value) {
      return Base64.encode(JSON.stringify(value));
    });
  }).filter('truncate', ['Utils', 'Validation', function (Utils, Validation) {
    return function truncate(str, len) {
      if (Utils.isArray(str)) {
        return _.map(str, _.partial(truncate, _, len));
      }
      if (Validation.isBlank(str) || str.length <= len) {
        return str;
      }
      if (str.match(/&#.+?;/)) {
        //if this string contains html encoded chars we have to prevent spliting on them
        var parts = str.split(/(&#.+?;)/),
          finalString = "",
          totalLength = 0;
        for (var i = 0; i < parts.length; i++) {
          var p = parts[i];
          if (p.indexOf("&#") === 0) {
            totalLength += 1;
          } else {
            p = p.substr(0, len - 3 - totalLength);
            totalLength += p.length;
          }
          finalString += p;
          if (totalLength > len - 3) {
            break;
          }
        }
        return finalString + "...";
      }
      return str.substr(0, Math.max(0, len - 3)) + "...";
    };
  }]).
  //
  // Duration filters
  //

  filter('minutes', function () {
    return function (centiseconds) {
      if (typeof centiseconds === "undefined" || centiseconds === null) {
        return "";
      }
      // using moment-duration-format plugin
      var time = moment.duration(centiseconds * 10).format("d [days], h [hours], m [minutes]");
      // remove trailing s from label when number is just 1
      return time.replace(/(^|, )1 ([^s]*)s/g, "$11 $2");
    };
  }).filter('seconds', function () {
    return function (centiseconds) {
      if (typeof centiseconds === "undefined" || centiseconds === null) {
        return "";
      }

      // using moment-duration-format plugin
      var time = moment.duration(centiseconds * 10).format("d [day], h [hour], m [minute], s [second]").split(",");

      //add "s" to time unit if value > 1
      var humanizedTime = "";
      time.forEach(function (element) {
        var elementSplit = element.trim().split(" "),
          elementValue = parseInt(elementSplit[0]);
        if (elementValue > 1 || elementValue < -1) {
          element = element + "s";
        }
        if (elementValue !== 0) {
          humanizedTime = humanizedTime ? humanizedTime + ", " + element : element;
        }
      });
      return humanizedTime;
    };
  }).
  //truncates the time "sentence" so that only the first n units display. For example if maxUnits = 2
  // and time sentence is "1 day, 3 hours, 4 minutes, 5 seconds" it would return: "1 day, 3 hours..."
  filter('truncatedTime', ['$filter', function ($filter) {
    return function (centiseconds, maxUnits) {
      if (typeof centiseconds === "undefined" || centiseconds === null) {
        return "";
      }
      var totalTime = $filter('seconds')(centiseconds),
        timeSplit = totalTime.split(","),
        i;
      if (timeSplit.length > maxUnits) {
        var truncatedTime = "";
        for (i = 0; i < maxUnits; i++) {
          truncatedTime += timeSplit[i] + ",";
        }
        return truncatedTime.replace(/,\s*$/, "") + "...";
      }
      return totalTime;
    };
  }]).
  // display durations using 1d 2h 4m 5s format
  filter('compactTime', function () {
    return function (centiseconds, showMilliseconds) {
      if (typeof centiseconds === "undefined" || centiseconds === null) {
        return "";
      }
      if (showMilliseconds) {
        return moment.duration(centiseconds * 10).format("y[y] d[d] h[h] m[m] s.SS[s]");
      } else {
        // using moment-duration-format plugin (add 500 ms to force rounding to nearest second)
        return moment.duration(centiseconds * 10 + 500).format("y[y] d[d] h[h] m[m] s[s]");
      }
    };
  }).
  // display durations in a very compact form (1d 2:04:05) for micro views
  filter('microTime', ['$filter', function ($filter) {
    return function (centiseconds) {
      if (typeof centiseconds === "undefined" || centiseconds === null) {
        return "";
      }

      // moment-duration-format plugin can't handle optional days & required hours, so using moment here
      var duration = moment.duration(centiseconds * 10),
        days = $filter('number')(duration.asDays(), 0),
        hours = duration.hours(),
        mins = duration.minutes(),
        secs = duration.seconds();

      //return moment.duration(centiseconds * 10).format("d[d] h:m:s");
      return (days > 0 ? days + 'd ' : '') + hours + ':' + (mins < 10 ? '0' + mins : mins) + ':' + (secs < 10 ? '0' + secs : secs);
    };
  }]).filter('pluralizeNoun', function () {
    return function (noun, count) {
      return pluralize(noun, count);
    };
  }).filter('personaDisplay', ['$sanitize', function ($sanitize) {
    return function (persona) {
      if (!persona) {
        return "";
      }
      /*jshint camelcase: false */
      var personaDisplay = persona.mbox ? persona.mbox.replace('mailto:', '') : persona.account ? persona.account.name + ' @ ' + persona.account.homePage : persona.openid ? persona.openid : persona.mbox_sha1sum ? persona.mbox_sha1sum : "";
      return sanitizeThenDecode($sanitize, personaDisplay);
    };
  }]).filter('sanitizeThenDecode', ['$sanitize', function ($sanitize) {
    return function (s) {
      if (!s) {
        return "";
      }
      return sanitizeThenDecode($sanitize, s);
    };
  }]).
  // accepts both statements and person objects
  filter('personDisplay', ['$filter', '$sanitize', 'wsConstants', 'TinCanJS', function ($filter, $sanitize, wsConstants, TinCanJS) {
    return function (object) {
      if (!object) {
        return "";
      }

      // treat object as statement; if no 'actor' property, then treat as a person object
      var actor = object.actor,
        actorName = object.actorName,
        person = actor ? actor.person : object;

      // try to display properties of person object
      if (person) {
        //Scorm Cloud sends UNKNOWN NAME sometimes, we don't want to show that
        if (person.name && person.name !== wsConstants.unknownActorName) {
          return sanitizeThenDecode($sanitize, person.name);
        }
        if (person.personas && person.personas.length > 0) {
          return $filter('personaDisplay')(person.personas[0]);
        }
      }

      // try to display statement properties
      if (actorName) {
        return sanitizeThenDecode($sanitize, actorName);
      }
      return sanitizeThenDecode($sanitize, TinCanJS.getActorName(actor || '--'));
    };
  }]).filter('personaHref', [function () {
    return function (persona) {
      if (!persona) {
        return "#";
      }
      /*jshint camelcase: false */
      var personaHref = persona.mbox ? persona.mbox : persona.account ? persona.account.homePage : "#";
      return personaHref;
    };
  }]).filter('personaContains', [function () {
    return function (personas, query) {
      return _.filter(personas, function (p) {
        if (p.mbox) {
          return p.mbox.indexOf(query) > -1;
        } else if (p.openid) {
          return p.openid.indexOf(query) > -1;
        } else if (p.account) {
          return p.account.name && p.account.name.indexOf(query) > -1 || p.account.homePage && p.account.homePage.indexOf(query) > -1;
        }
        return false;
      });
    };
  }]).filter('currentYear', ['$filter', function ($filter) {
    return function () {
      return $filter('date')(new Date(), 'yyyy');
    };
  }]).filter('pluck', ['Utils', function (Utils) {
    return function (item, field) {
      if (Utils.isArray(item)) {
        return _.pluck(item, field);
      } else {
        return item[field];
      }
    };
  }]).filter('trustAsHtml', ['$sce', function ($sce) {
    return function (text) {
      if (text) {
        return $sce.trustAsHtml('' + text);
      }
    };
  }]).filter('stripHtml', ['Utils', function (Utils) {
    return function (text) {
      return Utils.stripHTML(text);
    };
  }]).filter('nameList', [function () {
    return function (items, max) {
      var str = [];
      if (items.length === 0) {
        return '';
      }
      if (items.length === 1) {
        return items[0];
      }
      if (items.length === 2) {
        return items[0] + ' and ' + items[1];
      }
      if (items.length <= max) {
        return items.slice(0, items.length - 1).join(', ') + ', and ' + items[items.length - 1];
      } else {
        str = items.slice(0, max - 1).join(', ');
        var leftOver = items.length - (max - 1);
        if (leftOver === 1) {
          str += ', and ' + items[items.length - 1];
        } else {
          str += ', and ' + leftOver + ' others';
        }
        return str;
      }
    };
  }]).filter('taskId', function () {
    return function (text) {
      if (!text.includes(":")) {
        return "";
      }
      var split = text.split(":");
      return split[1];
    };
  }).filter('totalStatements', ['$filter', function ($filter) {
    return function (total, status) {
      if (status === "running" && total === 0) {
        return "calculating...";
      }
      return $filter('number')(total);
    };
  }]).
  /**
   * Take a continuous block of characters and split them into HTML chunks with a <br>
   * between each block. Can provide chunkSize; defaults to 80
   *
   * let str = 'asuperduperlongstringthatneedspropermanners';
   * Example: $filter('chunkify')(str, 5)
   *      <span>asupe<br>rdupe<br>...</span>
   * Rendered as:
   *      asupe
   *      rdupe
   *      rlong
   *      strin
   *      gthat
   *      needs
   *      prope
   *      rmann
   *      ers
   */
  filter('chunkify', ['$filter', function () {
    return function (fullText) {
      var chunkSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 80;
      var span = '<span>';
      for (var i = 0; i < fullText.length; i++) {
        if (i % chunkSize !== 0 || i === 0) {
          span += fullText[i];
        } else {
          span += "<br>";
        }
      }
      span += "</span>";
      return span;
    };
  }]).filter('stripSafeAngleBrackets', function () {
    return function (text) {
      var WHITELISTED_TAGS = ['<NO DESCRIPTION>'];
      text = text === 0 ? text : text || '';
      return WHITELISTED_TAGS.includes(text) ? text.replace(/[<>]/g, '') : text;
    };
  }).config(['$provide', function ($provide) {
    $provide.decorator('numberFilter', ['$delegate', '$locale', function ($delegate, $locale) {
      var formats = $locale.NUMBER_FORMATS;
      var numberFilter = $delegate;
      var extendNumberFilter = function extendNumberFilter() {
        //get the formatted number
        var formattedNumber = numberFilter.apply(this, arguments);

        //if null or undefined result return
        if (!formattedNumber) {
          return formattedNumber;
        }

        //find the decimal place
        var decimalIndex = formattedNumber.indexOf(formats.DECIMAL_SEP);
        if (decimalIndex < 0) {
          //if no decimal place return
          return formattedNumber;
        }

        //separate into whole number and decimal
        var whole = formattedNumber.substring(0, decimalIndex);
        //remove trailing zeros from decimal
        var decimal = (Number(formattedNumber.substring(decimalIndex)) || "").toString();
        return whole + decimal.substring(1);
      };
      return extendNumberFilter;
    }]);
  }]);
})();
